import { create } from "zustand";

// Zustand store for managing attendance data
export const useStudentAtdStore = create((set) => ({
    data: [], // Initialize the data array (attendance records)
    
    // Add a new row (attendance record) to the array
    addRow: (newRow) => set((state) => ({
        data: Array.isArray(newRow) ? [...state.data, ...newRow] : [...state.data, newRow], // If it's an array, spread and add each element; if it's a single object, just add it.
    })),

    // Filter attendance data by student_id
    filterById: (filterFunction) => set((state) => ({
        data: filterFunction(state.data), // Apply the provided filter function
    })),

    // Remove all entries from the attendance data array
    removeAll: () => set({
        data: [], // Empty the array
    }),

    // Get all attendance data
    getData: () => set((state) => state.data), // Retrieve the current data array
}));
